<template>
  <ExpansionPanel>
    <template #header>
      <div class="searchAreaStyle d-flex align-center mr-5">
        <span class="titleStyle font-weight-bold pl-10">
          {{ $t('common.common_search-customer-sale') }}
        </span>
      </div>
      <v-checkbox
        v-model="filter.isEnabled"
        :label="$t('common.common_hide-unused-customers')"
      />
    </template>
    <template #content>
      <div class="pa-6 master-list-search">
        <InputFormNew
          v-model="filter"
          :detail="clientDetail.customerInfo"
          :rowHeight="inputFormStyle.rowHeight"
          :titleCols="inputFormStyle.titleCols"
          :contentsCols="inputFormStyle.contentsCols"
        >
        </InputFormNew>
      </div>
    </template>
  </ExpansionPanel>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { ExpansionPanel } from '@/components/items'
import { InputFormNew } from '@/components/items'
import detail from './detail'

export default {
  components: {
    ExpansionPanel,
    InputFormNew
  },
  props: {
    filter: {}
  },
  data: () => {
    return {
      clientDetail: detail.detail,
      customerCategories: [],
      inputFormStyle: {
        rowHeight: '40px',
        titleCols: 3,
        contentsCols: 12 - 3,
        inputItemHeight: '32px'
      }
    }
  },
  async created() {
    this.getCustomerCategoryList()
  },
  methods: {
    ...mapActions('Common', ['getCustomerCategoryListFromApi']),
    ...mapGetters('Common', ['getCustomerCategoryFromState']),
    async getCustomerCategoryList() {
      await this.getCustomerCategoryListFromApi()
      this.customerCategories = this.getCustomerCategoryFromState()
    },
    createCustomerCategorySelectBoxValueFrom() {
      if (!this.customerCategories) {
        return
      }
      const result = [
        {
          value: undefined,
          label: ''
        }
      ]
      this.customerCategories.forEach((ele) => {
        result.push({
          value: ele.customerCategoryId,
          label: ele.name
        })
      })
      return result
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;
  .titleStyle {
    font-size: 18px;
  }
}
</style>
